import React, { useContext } from "react";
import { observer } from "mobx-react-lite";
import { Navigate, Outlet } from "react-router-dom";
import { Context } from "../../index.js";
import LoadingScreen from "../UI/Status/LoadingScreen.jsx";

const RequireAuth = observer(() => {
  const { store } = useContext(Context);

  if (store.isLoading) return <LoadingScreen />;
  if (!store.isAuth) return <Navigate to="/login" replace />;

  return <Outlet />;
});

export default RequireAuth;

